import {
  DocumentTypeEnum,
  GroupDocumentTypeEnum,
} from 'common/document/enums/document-type.enum';

export interface ICandidateDocument {
  label: string;
  value: GroupDocumentTypeEnum | DocumentTypeEnum;
}

export const labelsCandidateDocument = new Map([
  ['ONBOARDING', 'Compliance Docs'],
  ['DRIVER_LICENSE', 'License Front & Back'],
  ['DOT_MEDICAL', 'DOT Med Cert'],
  ['DRIVER_CHECKLIST', 'Driver Checklist'],
  ['RETURN_TO_WORK', 'Return to Work'],
  ['MEDICAL_DISCONTINUANCE', 'Medical Discontinuance Form'],
  ['PHOTO_ID', 'Photo ID'],
]);

export const labelsCandidateDocumentForTable = new Map([
  ['ONBOARDING', 'Compliance Docs'],
  ['DRIVER_LICENSE', 'License Front & Back'],
  ['DOT_MEDICAL', 'DOT Med Cert'],
  ['DRIVER_CHECKLIST', 'Driver Checklist'],
  ['RETURN_TO_WORK', 'Return to Work'],
  ['MEDICAL_DISCONTINUANCE', 'Medical Discontinuance Form'],
  ['PHOTO_ID', 'Photo ID'],
]);

export const Onboarding: ICandidateDocument = {
  label: labelsCandidateDocument.get(GroupDocumentTypeEnum.ONBOARDING) || '',
  value: GroupDocumentTypeEnum.ONBOARDING,
};

export const CDL: ICandidateDocument = {
  label: labelsCandidateDocument.get(DocumentTypeEnum.DRIVER_LICENSE) || '',
  value: DocumentTypeEnum.DRIVER_LICENSE,
};

export const DOTMedCert: ICandidateDocument = {
  label: labelsCandidateDocument.get(DocumentTypeEnum.DOT_MEDICAL) || '',
  value: DocumentTypeEnum.DOT_MEDICAL,
};

export const DriverChecklist: ICandidateDocument = {
  label: labelsCandidateDocument.get(DocumentTypeEnum.DRIVER_CHECKLIST) || '',
  value: DocumentTypeEnum.DRIVER_CHECKLIST,
};

export const ReturnToWork: ICandidateDocument = {
  label: labelsCandidateDocument.get(DocumentTypeEnum.RETURN_TO_WORK) || '',
  value: DocumentTypeEnum.RETURN_TO_WORK,
};

export const MedicalDisontinuance: ICandidateDocument = {
  label:
    labelsCandidateDocument.get(DocumentTypeEnum.MEDICAL_DISCONTINUANCE) || '',
  value: DocumentTypeEnum.MEDICAL_DISCONTINUANCE,
};

export const PhotoIdDocument: ICandidateDocument = {
  label: labelsCandidateDocument.get(DocumentTypeEnum.PHOTO_ID) || '',
  value: DocumentTypeEnum.PHOTO_ID,
};
